import { ReactNode, useState } from 'react';

import { ReactComponent as ChevronDownIcon } from '../../../../assets/icons/chevron-down.svg';

import './ExpandableCard.scss';

interface IExpandableCardProps {
  title: string | ReactNode;
  trailingComponent?: ReactNode;
  children: ReactNode;
  className?: string;
  defaultExpanded?: boolean;
}

const ExpandableCard = ({
  title,
  trailingComponent,
  children,
  className = '',
  defaultExpanded = false
}: IExpandableCardProps) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const handleToggle = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <section className={`expandable-card ${className}`.trim()}>
      <button type="button" className="expandable-card__header" onClick={handleToggle} aria-expanded={expanded}>
        <span className="expandable-card__title">{title}</span>
        <div className="expandable-card__header-right">
          {trailingComponent && <div className="expandable-card__trailing">{trailingComponent}</div>}
          <span
            className={`expandable-card__toggle${!expanded ? ' expandable-card__toggle--collapsed' : ''}`}
            aria-hidden="true"
          >
            <ChevronDownIcon className="expandable-card__toggle__icon" />
          </span>
        </div>
      </button>

      {expanded && (
        <>
          <div className="expandable-card__separator" />
          {children}
        </>
      )}
    </section>
  );
};

export default ExpandableCard;
